// Webhook Configuration
// You can modify these values based on your environment
// For production, consider using environment variables or server-side configuration

export const webhookConfig = {
  // Webhook URL
  url: process.env.REACT_APP_WEBHOOK_URL || '', 
  
  // Authentication credentials
  // In production, these should be set via environment variables:
  // REACT_APP_WEBHOOK_USERNAME and REACT_APP_WEBHOOK_PASSWORD
  username: process.env.REACT_APP_WEBHOOK_USERNAME || '',
  password: process.env.REACT_APP_WEBHOOK_PASSWORD || '',
  
  // Request timeout in milliseconds
  timeout: 10000,
  
  // Additional headers (if needed)
  additionalHeaders: {
    // Add any additional headers here
    // 'X-Custom-Header': 'value'
  }
};

// Helper function to get authentication header
export const getAuthHeader = () => {
  const { username, password } = webhookConfig;
  
  if (username && password) {
    return `Basic ${btoa(`${username}:${password}`)}`;
  }
  
  return '';
};

// Helper function to get all headers
export const getHeaders = () => {
  const authHeader = getAuthHeader();
  
  return {
    'Content-Type': 'application/json',
    ...(authHeader && { 'Authorization': authHeader }),
    ...webhookConfig.additionalHeaders
  };
}; 